import Search from '../src/Search/index.tsx';
export default Search;
